import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TrendingUp from "@material-ui/icons/TrendingUp";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Info from "components/Typography/Info.js";
import Success from "components/Typography/Success.js";
import Danger from "components/Typography/Danger.js";

import bg5 from "assets/img/bg5.jpg";
import blog5 from "assets/img/examples/blog5.jpg";
import blog6 from "assets/img/examples/blog6.jpg";

import sectionInterestedStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionInterestedStyle.js";

const useStyles = makeStyles(sectionInterestedStyle);

export default function SectionInterested() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <h3 className={classes.title + " " + classes.textCenter}>
        Bunlar da İlginizi Çekebilir
      </h3>
      <br />
      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>
              <a href="#pablo">
                <img src={bg5} alt="..." />
              </a>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + bg5 + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>ÜRETİKENLİK</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <a href="#pablo">Zaman Yönetimi İçin 3 Altın Kural</a>
              </h4>
              <p className={classes.description}>
                Günlük hayatın koşturmasında zamanı doğru kullanmak zor olabilir.
                Bu yazımızda üretkenliğinizi artıracak basit ama etkili yöntemleri derledik.
                <a href="#pablo"> Devamını Oku </a>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <a href="#pablo">
                <img src={blog5} alt="..." />
              </a>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + blog5 + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Success>
                <h6>AJANDA RUTİNLERİ</h6>
              </Success>
              <h4 className={classes.cardTitle}>
                <a href="#pablo">Her Sabah 10 Dakikada Günü Planlama</a>
              </h4>
              <p className={classes.description}>
                Sabah rutininize ajandanızı ekleyerek hem zihninizi netleştirin
                hem de hedeflerinize daha kolay ulaşın.
                <a href="#pablo"> Yazıyı Oku </a>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <a href="#pablo">
                <img src={blog6} alt="..." />
              </a>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + blog6 + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Danger>
                <h6>
                  <TrendingUp /> KİŞİSEL GELİŞİM
                </h6>
              </Danger>
              <h4 className={classes.cardTitle}>
                <a href="#pablo">Not Almanın Gücü: Kalem ve Kağıtla Düşünmek</a>
              </h4>
              <p className={classes.description}>
                Dijital çağda her şey ekranlarda ama el yazısıyla not almanın
                zihinsel faydaları hâlâ rakipsiz. Neden yazmalı, neden planlamalı?
                <a href="#pablo"> Detayları Gör </a>
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
